// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-header .v-toolbar__content{padding:0}@media only screen and (max-width:990px){.hiddenIn990{display:none!important}}.header{background-image:url(/media/bg/bg-10.jpg);background-position:top;background-size:cover;width:100%}", ""]);
// Exports
module.exports = exports;
